import { useQuery } from '@tanstack/react-query';
import { userManagementService } from '@/api/services/UserManagementService';

export const EMPLOYEE_INVITATIONS_QUERY_KEY = ['employee-invitations'] as const;

/**
 * Приглашения сотрудников организации. Единый источник для вкладки «Сотрудники» и онбординг-карточки
 * Главной — общий ключ, поэтому react-query разделяет кэш и не запрашивает дважды.
 *
 * Запрос доступен аттестованной организации (иначе бэкенд отвечает 406). Параметр `enabled` позволяет
 * вызывающему не отправлять заведомо отклоняемый запрос (например, до аттестации или не менеджеру).
 */
export function useEmployeeInvitations(enabled = true) {
  return useQuery({
    queryKey: EMPLOYEE_INVITATIONS_QUERY_KEY,
    queryFn: () => userManagementService.getEmployeeInvitations(),
    staleTime: 60_000,
    enabled,
  });
}
